import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalRecruiting`,
  scopes: ExtHubRequest,
});

api.createEntities([{ name: 'GetRecruitingItems' }]);

const GetRecruitingItems = () => api.endpoints.GetRecruitingItems.post();

export { GetRecruitingItems };
